import React from "react";

// Mui
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid2";

// Mui Styles
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";
import { ThemeProvider } from "@mui/material/styles";

// Navigate
import { useCurrentAction } from "@/hooks/user";
import { useNavigate } from "react-router-dom";
// Components
import BlogCard from "@/components/blogCard";
import {
  EscapeRegExp,
  SearchingBar,
} from "@/components/DataTable/searchingBar";
import Layout from "@/components/layout";
import Title from "@/components/title";

// Fetch
import { getAllNotice } from "@/fetch/fetchNotice";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";

const NoticePage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();
  // Navigate
  const navigate = useNavigate();

  // States
  const [noticeData, setNoticeData] = React.useState([]);
  const [slideTranOn, setSlideTranOn] = React.useState(false);
  const [searchText, setSearchText] = React.useState("");
  const [rowsData, setRowsData] = React.useState([]);

  const onClickCreate = () => {
    navigate("create");
  };

  const onClickEdit = (id) => {
    navigate(`edit/${id}`);
  };

  const requestSearch = (searchValue) => {
    setSearchText(searchValue);
    const searchRegex = new RegExp(EscapeRegExp(searchValue), "i");
    const filteredRows = noticeData.filter((row) => {
      return Object.keys(row).some((field) => {
        return searchRegex.test(row[field].toString());
      });
    });
    setRowsData(filteredRows);
  };

  // Fetch
  const fetchAll = async () => {
    await getAllNotice().then((data) => {
      if (data && data.results) {
        let tempArr = [...data.data];
        for (let i = 0; i < tempArr.length; i++) {
          if (tempArr[i].time_created) {
            tempArr[i].time_created = moment(tempArr[i].time_created).format(
              "YYYY-MM-DD"
            );
          }
          if (tempArr[i].time_modified) {
            tempArr[i].time_modified = moment(tempArr[i].time_modified).format(
              "YYYY-MM-DD"
            );
          }
        }
        setNoticeData(tempArr);
        setRowsData(tempArr);
        setTimeout(() => {
          setSlideTranOn(true);
        }, 200);
      }
    });
  };

  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    setRowsData(noticeData);
  }, [noticeData]);

  return (
    <Layout header="NoticePage" selectedIndex={2} open={open} setOpen={setOpen}>
      <Title
        FunctionOn={actions?.create}
        title="內部公告"
        createName="新增公告"
        onClickCreate={() => onClickCreate()}
      />
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <SearchingBar
            onChange={(event) => requestSearch(event.target.value)}
            value={searchText}
            clearSearch={() => requestSearch("")}
          />
        </ThemeProvider>
      </StyledPaper>
      <Fade in={slideTranOn} mountOnEnter unmountOnExit>
        <StyledPaper page={"yes"}>
          <Grid container spacing={2}>
            {rowsData.length > 0 &&
              rowsData.map((data, index) => (
                <Grid
                  key={index}
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 3
                  }}>
                  <BlogCard
                    type="notice"
                    {...data}
                    onClick={() => onClickEdit(data.id)}
                  />
                </Grid>
              ))}
          </Grid>
        </StyledPaper>
      </Fade>
    </Layout>
  );
};

export default NoticePage;
